import Products from "./components/manager/Products";
import Menus from "./components/manager/Menus";
import PRs from "./components/manager/PRs";
import PRStats from "./components/manager/PRStats";
import Register from "./components/manager/Register";
import ManagerData from "./components/manager/ManagerData";
import ManagerArea from "./components/manager/ManagerArea";
import Employees from "./components/manager/Employees";
import Login from "./components/login/Login"

export const routes = [
    {path: '/sign-in', component: Login, meta: { requiresAuth: false }},
    {path: '/sign-up', component: Register, meta: { requiresAuth: false }},
    {
        path: '/', component: ManagerArea, meta: { requiresAuth: true },
        children: [
            {path: '', component: ManagerData},
            {path: 'products', component: Products},
            {path: 'employees', component: Employees},
            {path: 'menus', component: Menus},
            {path: 'public-relations', component: PRs},
            {path: 'public-relations/stats', component: PRStats},
        ]
    },
    // otherwise redirect to home
    { path: '*', redirect: '/' }


];
